import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import BgMaxPrice from './BgMaxPrice';
import ErrorResponse from './ErrorResponse';
import mapBgMaxPrice from './mapBgMaxPrice';

export interface Result {
	bgMaxPrice: BgMaxPrice;
}

export default function findBgMaxPrice(client: ApiClient, userId: string, groupId: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/bg-max-price');
	return client
		.fetch(url.expand({ userId, groupId }))
		.then((response) => response.json())
		.then((response) => ({
			bgMaxPrice: mapBgMaxPrice(response.bgMaxPrice),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
